import { _t } from '@bark/bark-core';
import { BarkPaymentsCardModal } from './credit-card';

export const handleScaAuthenticationRequest = (
	$creditModal,
	client_secret,
	successCallback,
	failureCallback,
) => {
	BarkPaymentsCardModal.promptUserAction(
		client_secret,
		(result) => {
			if (result?.paymentIntent) {
				successCallback(result?.paymentIntent);
			} else {
				if (failureCallback) {
					failureCallback();
				} else {
					BarkPaymentsCardModal.hideModalErrorText($creditModal);
					BarkPaymentsCardModal.showCardModal($creditModal);
					BarkPaymentsCardModal.showModalErrorText(
						$creditModal,
						_t('seller_payments:sca.errors.authentication-error'),
					);
				}
			}
		},
		() => {
			// It is not clear if this is ever likely to happen, but we log it to bugsnag, so if it does a lot
			// then we can improve this error messaging.
			window.Bark.alertModal(_t('seller_payments:sca.errors.generic-error'));
		},
	);
};
